import React, { ForwardedRef, useCallback, useEffect, useState } from 'react';
import MuiAlert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';


const AlertSnackBar = ({
  openState,
  toggleOpenState,
  duration,
  severity,
  message,
}: {
  openState: boolean;
  toggleOpenState: () => void;
  duration: number;
  severity: string;
  message: string;
}) => {
  const Alert = React.forwardRef(function Alert(
    props: any,
    ref: ForwardedRef<HTMLDivElement>,
  ) {
    return (
      <MuiAlert
        elevation={6}
        ref={ref}
        variant='filled'
        {...props}
      />
    );
  });

  const AlertSnackBarHelper = useCallback(() => {
    // console.log("alertSnackBar open", openState, duration, severity, message)
    return (
      <Snackbar
        open={openState}
        autoHideDuration={duration}
        onClose={(_, closeReason) => {
          if (closeReason !== 'clickaway') toggleOpenState();
        }}
      >
        <Alert
          onClose={() => {
            toggleOpenState();
          }}
          severity={severity}
          sx={{ width: '100%' }}
        >
          {message}
        </Alert>
      </Snackbar>
    );
  }, [openState, duration, severity, message]);

  return (
    <>
      <AlertSnackBarHelper />
    </>
  );
};

export default AlertSnackBar;
